<template>
    <div>
        <!-- loading spinner -->
        <div v-if="!deviceDataLoaded" id="live-data-loading" style="text-align: center;">
            <div class="lds-facebook"><div></div><div></div><div></div></div>
            <div>Connecting to live data feed...</div>
        </div>

        <!-- content -->
        <div v-else>
            <!-- controls -->
            <div style="width: 100%; float:left;">
                <!-- live data -->
                <div style="position: relative; padding-left:20px; padding-top: 5px; float: left;">
                    <span style="color:red; font-weight: bold;">LIVE DATA</span>
                    <svg height="50" width="50" class="blinking" style="position:absolute; top:-4px; left:-11px;">
                        <circle cx="20" cy="20" r="5" fill="red" />
                    </svg> 
                </div>

                <!-- export to exccel button -->
                <button type="button" style="float: right; margin-bottom: 25px; margin-left: 15px;" class="btn btn-primary btn-sm" @click="exportExcel()">
                    <i class="fa-solid fa-file-arrow-down"></i>
                    <span style="padding-left: 10px">Export Excel</span>
                </button>

                <!-- data select dwondown -->
                <b-form-select style="float: right; width: 150px;" v-model="dataSelection" :options="dataSelectionOptions" @change="dataSelectionChange()" size="sm"></b-form-select>                

                <!-- search box -->
                <b-input-group style="float: right; width: 200px; margin-right: 15px;">
                    <b-input-group-prepend>
                        <span class="input-group-text"><i class="fa-solid fa-magnifying-glass"></i></span>
                    </b-input-group-prepend>
                    <b-form-input class="LoginInput" size="sm" placeholder="Search"></b-form-input>
                </b-input-group>                

                <!-- Smmmary Info -->
                <div style="width: 100%; float: left; padding-bottom: 16px;">
                    <div style="float: left">
                        <div v-if="newBatch" id="today-count" class="animate__animated animate__rubberBand" style="position: absolute; z-index: 999; font-size: 39px; color: #28a745;"><b>{{ (dataSelection == 'aquaculture'  ? dataItemsAquacultureToday : dataItemsToday )}}</b></div>
                        <div v-else id="today-count" style="position: absolute; font-size: 39px;"><b>{{ (dataSelection == 'aquaculture'  ? dataItemsAquacultureToday : dataItemsToday )}}</b></div>
                        <div v-if="newBatch" style="margin-top: -7px; color: #28a745; height: 55px;">BATCHES TODAY</div>
                        <div v-else style="margin-top: -7px; color: grey">BATCHES TODAY</div>
                    </div>
                    <div style="float: left; padding-left: 45px">
                        <div style="position: absolute; font-size: 39px; color: #6c757d; font-weight: 200;">{{ (dataSelection == 'aquaculture'  ? dataItemsAquaculture.length : dataItems.length) }}</div>
                        <div style="margin-top: -7px; color: grey; height: 55px;">BATCHES TOTAL</div>
                    </div>

                    <!-- <button type="button" @click="batchCountUpdate()" class="btn btn-primary btn-sm action-button">
                        Test
                    </button> -->
                </div>

            </div>

            <!-- Grid basic -->
            <div :class="dataSelection == 'basic' ? 'show-grid' : 'hide-grid'" id="deviceBatchData_grid_basic" style="width: 100%; float:left;">
                <Grid
                    :style="{ 
                        'font-size': '13px',
                        'height': 'calc(100vh - 409px)'
                    }"
                    :data-items="dataItems"
                    :sortable="true"
                    :sort="sort"
                    :pageable="false"
                    :skip="skip"
                    :take="take"
                    :total="total"
                    :columns="columnsBasic"
                    @pagechange="pageChangeHandler"
                    @sortchange="sortChangeHandler"
                    :loader="loader"
                    @rowclick="onRowClick"
                    >
                </Grid>
            </div>

            <!-- Grid advanced-->
            <div :class="dataSelection == 'advanced' ? 'show-grid' : 'hide-grid'" id="deviceBatchData_grid_advanced" style="width: 100%; float:left;">
                <Grid
                    :style="{ 
                        'font-size': '13px',
                        'height': 'calc(100vh - 409px)'
                    }"
                    :data-items="dataItems"
                    :sortable="true"
                    :sort="sort"
                    :pageable="false"
                    :skip="skip"
                    :take="take"
                    :total="total"
                    :columns="columnsAdvanced"
                    @pagechange="pageChangeHandler"
                    @sortchange="sortChangeHandler"
                    :loader="loader"
                    @rowclick="onRowClick"
                    >
                </Grid>
            </div>

            <!-- Grid Aquaculture-->
            <div :class="dataSelection == 'aquaculture' ? 'show-grid' : 'hide-grid'" id="deviceBatchData_grid_aquaculture" style="width: 100%; float:left;">
                <Grid
                    :style="{ 
                        'font-size': '13px',
                        'height': 'calc(100vh - 409px)'
                    }"
                    :data-items="dataItemsAquaculture"
                    :sortable="true"
                    :sort="sort"
                    :pageable="false"
                    :skip="skip"
                    :take="take"
                    :total="totalAquaculture"
                    :columns="columnsAquaculture"
                    @pagechange="pageChangeHandler"
                    @sortchange="sortChangeHandler"
                    :loader="loader"
                    @rowclick="onRowClick"
                    >
                </Grid>
            </div>

            <!-- item count -->
            <div>
                <div id="item-count">
                    Items: {{ (dataSelection == 'aquaculture' ? dataItemsAquaculture.length : dataItems.length ) }}
                </div>
            </div>

        </div>

        <!-- Batch Playback modal -->
        <b-modal :id="'batch-playback-modal'" :ref="'batch-playback-modal'" size="xl" class="xxl-modal" scrollable @hide="batchPlaybackHide()">
            <BatchPlayback :item="item" :BatchID="selectedBatchID" ref="BatchPlayback" />

            <template #modal-footer>
                <button v-b-modal.modal-close_visit class="btn btn-sm btn-secondary" @click="$bvModal.hide('batch-playback-modal')">Close</button>
            </template>
        </b-modal>
    </div>    
</template>

<script>
    import { Grid } from '@progress/kendo-vue-grid';
    import { saveExcel } from '@progress/kendo-vue-excel-export';
    import moment from 'moment';

    import BatchPlayback from './BatchPlayback.vue';

    export default {
        name: 'DeviceDataBatches',
        components: {
            Grid: Grid,
            BatchPlayback,
        },
        data: function () {
            return {
                selectedBatchID: null,
                deviceBatchData: [],
                deviceBatchDataAquaculture: [],
                deviceDataLoaded: false,
                loader: false,
                dataItems: [],
                dataItemsAquaculture: [],
                dataItemsAquacultureToday: 0,
                dataItemsToday: 0,
                skip: 0,
                take: 10,
                sort: [{ field: 'BatchID', dir: 'asc' }],
                columnsBasic: [
                 //   { field: 'Playback', title: 'Playback', width: 70 },
                    { field: 'BatchID', title: 'ID', width: 100 },
                    { field: 'Processed', title: 'Processed', width: 120 },
                    { field: 'Started', title: 'Started' },
                    { field: 'Finished', title: 'Finished' },
                    { field: 'Protocol', title: 'Protocol' },
                    { field: 'Product', title: 'Product' },
                    { field: 'Pack Qty', title: 'Pack Qty' },
                    { field: 'Pack Volume', title: 'Pack Volume' },
                    { field: '% Cryoprotectant', title: '% Cryoprotectant' },
                ],
                columnsAdvanced: [
                 //   { field: 'Playback', title: 'Playback', width: 70 },
                    { field: 'BatchID', title: 'ID', width: 100, locked: true },
                    { field: 'Processed', title: 'Processed', width: 120, locked: true },
                    { field: 'Started', title: 'Started', width: 200, locked: true },
                    { field: 'Finished', title: 'Finished', width: 200 },
                    { field: 'Code', title: 'Code', width: 200 },
                    { field: 'Protocol', title: 'Protocol', width: 200 },
                    { field: 'Product', title: 'Product', width: 200 },
                    { field: 'Pack Qty', title: 'Pack Qty', width: 200 },
                    { field: 'Pack Volume', title: 'Pack Volume', width: 200 },
                    { field: 'Weight/Vol', title: 'Weight/Vol', width: 200 },
                    { field: 'Temp Setpoint', title: 'Temp. Setpoint', width: 200 },
                    { field: 'Temp Tolerance', title: 'Temp. Tolerance', width: 200 },
                    { field: 'Flow Setpoint', title: 'Flow Setpoint', width: 200 },
                    { field: 'Flow Tolerance', title: 'Flow Tolerance', width: 200 },
                    { field: 'Process Time', title: 'Process Time', width: 200 },
                    { field: 'Start Temp', title: 'Start Temp.', width: 200 },
                    { field: 'End Temp', title: 'End Temp.', width: 200 },
                    { field: 'Min Temp', title: 'Min Temp.', width: 200 },
                    { field: 'Max Temp', title: 'Max Temp.', width: 200 },
                    { field: 'Start Flow', title: 'Start Flow', width: 200 },
                    { field: 'End Flow', title: 'End Flow', width: 200 },
                    { field: 'Min Flow', title: 'Min Flow', width: 200 },
                    { field: 'Max Flow', title: 'Max Flow', width: 200 },
                ],
                columnsAquaculture: [
                   // { field: 'Playback', title: 'Playback', width: 70 },
                    { field: 'BatchID', title: 'ID', width: 100, locked: true },
                    { field: 'Processed', title: 'Processed', width: 120, locked: true },
                    { field: 'StartDateTime', title: 'Started', width: 200, locked: true },
                    { field: 'EndDateTime', title: 'Finished', width: 200 },
                    { field: 'ProtocolOEMCode', title: 'Code', width: 200 },
                    { field: 'ProtocolOEMDesc', title: 'Protocol', width: 200 },
                    { field: 'NumberOfFish', title: 'Number of Fish', width: 200 },
                    { field: 'FishID_1', title: 'Fish 1 ID', width: 200 },
                    { field: 'PackageQuantity_1', title: 'Package 1 Quantity', width: 200 },
                    { field: 'TotalMotility_1', title: 'Fish 1 Total Motility', width: 200 },
                    { field: 'Concentration_1', title: 'Fish 1 Concentration', width: 200 },
                    { field: 'Grade_1', title: 'Fish 1 Grade', width: 200 },
                    { field: 'Cryoprotectant_1', title: 'Package 1 Cryoprotectant', width: 200 },
                    { field: 'FishID_2', title: 'Fish 2 ID', width: 200 },
                    { field: 'PackageQuantity_2', title: 'Package 2 Quantity', width: 200 },
                    { field: 'TotalMotility_2', title: 'Fish 2 Total Motility', width: 200 },
                    { field: 'Concentration_2', title: 'Fish 2 Concentration', width: 200 },
                    { field: 'Grade_2', title: 'Fish 2 Grade', width: 200 },
                    { field: 'Cryoprotectant_2', title: 'Package 2 Cryoprotectant', width: 200 },
                    { field: 'FishID_3', title: 'Fish 3 ID', width: 200 },
                    { field: 'PackageQuantity_3', title: 'Package 3 Quantity', width: 200 },
                    { field: 'TotalMotility_3', title: 'Fish 3 Total Motility', width: 200 },
                    { field: 'Concentration_3', title: 'Fish 3 Concentration', width: 200 },
                    { field: 'Grade_3', title: 'Fish 3 Grade', width: 200 },
                    { field: 'Cryoprotectant_3', title: 'Package 3 Cryoprotectant', width: 200 },
                    { field: 'Flow Tolerance', title: 'Flow Tolerance', width: 200 },
                    { field: 'Process Time', title: 'Process Time', width: 200 },
                    { field: 'Start Temp', title: 'Start Temp.', width: 200 },
                    { field: 'End Temp', title: 'End Temp.', width: 200 },
                    { field: 'Min Temp', title: 'Min Temp.', width: 200 },
                    { field: 'Max Temp', title: 'Max Temp.', width: 200 },
                    { field: 'Start Flow', title: 'Start Flow', width: 200 },
                    { field: 'End Flow', title: 'End Flow', width: 200 },
                    { field: 'Min Flow', title: 'Min Flow', width: 200 },
                    { field: 'Max Flow', title: 'Max Flow', width: 200 },
                ],
                search: null,
                dataSelectionOptions: [{ value: 'basic', text: 'Basic'}, { value: 'advanced', text: 'Advanced' }, {value: 'aquaculture', text: 'Aquaculture'}],
                dataSelection: 'basic',
                newBatch: false,
                previousCountAquaculture: null,
                previousCount: null,
                initialLoad: true,
                initialLoadAquaculture: true,
            };
        },
        props: ['item', 'autoUpdateDeviceData'],
        computed: {
            result: {
                get: function () {
                    return this.dataItems.slice(this.skip, this.take + this.skip);
                },
            },
            total() {
                return this.dataItems ? this.dataItems.length : 0;
            },
            totalAquaculture() {
                return this.dataItemsAquaculture ? this.dataItemsAquaculture.length : 0;
            },
        },
        mounted() {
            this.getBatchata();
            this.getBatchDataAquaculture();
            //this.dataItems = this.createRandomData(1000);

            // device data auto fetch
            console.log("HERE");
            console.log("autoUpdateDeviceData = " + this.autoUpdateDeviceData);
            this.timer3 = setInterval(() => {
                if(this.autoUpdateDeviceData) {
                    console.log("device data fetch!!!");
                    console.log("autoUpdateDeviceData = " + this.autoUpdateDeviceData);
                    this.getBatchata();
                    this.getBatchDataAquaculture();
                }
            }, 30000) // 30 sec

            // set to aquaculture table for Vitrafy-00001
            if(this.item.id == "Vitrafy-00001") {
                this.dataSelection = "aquaculture";           
            }

            // dynamically set height of google maps component
            document.getElementById("map-container").style.height = "calc(100vh - 419px)";
        },
        methods: {
            async getBatchata() {
                this.newBatch = false;
                this.previousCount = this.dataItems.length;

                console.log("this.previousCount = " + this.previousCount);

                let url = process.env.VUE_APP_MULE_PROXY_API_URI;

                var data = {
                    "endpoint": "/api/devices/" + this.item.id + "/data/batches?reportType=advanced"
                };

                data = JSON.stringify(data);

                let headers = {
                    'Content-Type': 'application/json;charset=utf-8',
                    'authorization': localStorage.idtoken
                };          

                try {
                    const response = await this.$http.post(
                        url,
                        data,
                        {headers: headers}
                    );

                    var options = { hour12: false };

                    this.dataItemsToday = 0;

                    for(var i = 0; i < response.data.length; i++) {
                        // add id for table
                        response.data[i].id = i + 1;

                        // format dates
                        if(response.data[i].Started  != null) {
                            response.data[i]['Processed'] = moment(response.data[i].Started).fromNow();
                            response.data[i].Started = new Date(response.data[i].Started).toLocaleString('en-AU', options);
                        }
                        if(response.data[i].Finished  != null) {
                            response.data[i].Finished = new Date(response.data[i].Finished).toLocaleString('en-AU', options);
                        }

                        // adjusting field names
                        response.data[i]['Temp Setpoint'] = response.data[i]['Temp. Setpoint'];
                        response.data[i]['Temp Tolerance'] = response.data[i]['Temp. Tolerance'];
                        response.data[i]['Start Temp'] = response.data[i]['Start Temp.'];
                        response.data[i]['End Temp'] = response.data[i]['End Temp.'];
                        response.data[i]['Min Temp'] = response.data[i]['Min Temp.'];
                        response.data[i]['Max Temp'] = response.data[i]['Max Temp.'];

                        // calc daily bathces count
                        var batchStartDate = response.data[i].Started.substring(0,10);
                        var todaysDate = moment().format('DD/MM/YYYY');
                        if(batchStartDate == todaysDate) {
                            this.dataItemsToday++;
                        }
                    }

                    this.deviceBatchData = response.data;
                    this.deviceDataLoaded = true;

                    // for kendo grid
                    this.dataItems = this.deviceBatchData;

                    // highlight new batch count if it's increaed
                    console.log("this.dataItems.length= " + this.dataItems.length);

                    if(!this.initialLoad && this.dataItems.length > this.previousCount) {
                        this.newBatch = true;
                    }

                    this.initialLoad = false;
                    
                } catch (error) {
                    console.log(error);
                }
            },
            async getBatchDataAquaculture()
            {
                this.newBatch = false;
                this.previousCountAquaculture = this.dataItemsAquaculture.length;

                console.log("this.previousCountAquaculture = " + this.previousCountAquaculture);


                let url = process.env.VUE_APP_MULE_PROXY_API_URI;

                var data = {
                    "endpoint": "/api/devices/" + this.item.id + "/data/batches?reportType=aquaculture"
                };

                data = JSON.stringify(data);

                let headers = {
                    'Content-Type': 'application/json;charset=utf-8',
                    'authorization': localStorage.idtoken
                };          

                try {
                    const response = await this.$http.post(
                        url,
                        data,
                        {headers: headers}
                    );

                    var options = { hour12: false };

                    this.dataItemsAquacultureToday = 0;

                    for(var i = 0; i < response.data.length; i++) {
                        // add id for table
                        response.data[i].id = i + 1;

                        // format dates
                        if(response.data[i].StartDateTime  != null) {
                            response.data[i]['Processed'] = moment(response.data[i].StartDateTime).fromNow();
                            response.data[i].StartDateTime = new Date(response.data[i].StartDateTime).toLocaleString('en-AU', options);
                        }
                        if(response.data[i].EndDateTime  != null) {
                            response.data[i].EndDateTime = new Date(response.data[i].EndDateTime).toLocaleString('en-AU', options);
                        }

                        // adjusting field names
                        response.data[i]['Temp Setpoint'] = response.data[i].Temperature;
                        response.data[i]['Temp Tolerance'] = response.data[i].TempTol;
                        response.data[i]['Start Temp'] = response.data[i].StartTemp;
                        response.data[i]['Start Flow'] = response.data[i].StartFlow;
                        response.data[i]['End Flow'] = response.data[i].EndFlow;
                        response.data[i]['Flow Setpoint'] = response.data[i].Flow;
                        response.data[i]['Flow Tolerance'] = response.data[i].FlowTol;
                        response.data[i]['End Temp'] = response.data[i].EndTemp;
                        response.data[i]['Min Temp'] = response.data[i].MinTemp;
                        response.data[i]['Max Temp'] = response.data[i].MaxTemp;
                        response.data[i]['Min Flow'] = response.data[i].MinFlow;
                        response.data[i]['Max Flow'] = response.data[i].MaxFlow;
                        response.data[i]['Process Time'] = response.data[i].ProcessTime;

                        // calc daily bathces count
                        var batchStartDate = response.data[i].StartDateTime.substring(0,10);
                        var todaysDate = moment().format('DD/MM/YYYY');
                        if(batchStartDate == todaysDate) {
                            this.dataItemsAquacultureToday++;
                        }

                    }

                    this.deviceBatchDataAquaculture = response.data;
                    this.deviceDataLoaded = true;

                    // for kendo grid
                    this.dataItemsAquaculture = this.deviceBatchDataAquaculture;

                    // highlight new batch count if it's increaed

                    console.log("this.dataItemsAquaculture.length= " + this.dataItemsAquaculture.length);

                    if(!this.initialLoadAquaculture && this.dataItemsAquaculture.length > this.previousCountAquaculture) {
                        this.newBatch = true;
                    }

                    this.initialLoadAquaculture = false;

                } catch (error) {
                    console.log(error);
                }
            },
            onRowClick(event){
                // console.log("Row clicked:")
                // console.log(event)
                // console.log("Selected Batch ID: " + event.dataItem.BatchID)
                this.selectedBatchID = event.dataItem.BatchID

                this.$refs['batch-playback-modal'].show()
            },
            batchPlaybackHide()
            {
                this.selectedBatchID=null;
            },
            pageChangeHandler: function (event) {
                this.loader = true;
                // The idea behind using the following setTimeout method is to
                // demonstrate how we can show a loader while fetching data.
                // In a real-life scenarios with remote data binding, the 'loader'
                // property should be updated before making a server request
                // and after the request completes.
                setTimeout(() => {
                this.loader = false;
                this.skip = event.page.skip;
                this.take = event.page.take;
                }, 300);
            },
            sortChangeHandler: function (e) {
                this.loader = true;
                // The idea behind using the following setTimeout method is to
                // demonstrate how we can show a loader while fetching data.
                // In a real-life scenarios with remote data binding, the 'loader'
                // property should be updated before making a server request
                // and after the request completes.
                setTimeout(() => {
                    this.loader = false;
                    this.sort = e.sort;
                }, 200);
            },
            exportExcel() {
                if(this.dataSelection == 'basic') {
                    saveExcel({
                        data: this.deviceBatchData,
                        fileName: "deviceBatchData-basic",
                        columns: [
                            { field: 'Started', title: 'Started' },
                            { field: 'Finished', title: 'Finished' },
                            { field: 'Protocol', title: 'Protocol' },
                            { field: 'Product', title: 'Product' },
                            { field: 'Pack Qty', title: 'Pack Qty' },
                            { field: 'Pack Volume', title: 'Pack Volume' },
                            { field: '% Cryoprotectant', title: '% Cryoprotectant' },
                        ],
                    });
                }
                else if (this.dataSelection == 'aquaculture') {
                    const fileName = "deviceBatchData-Aquaculture";
                    console.log(fileName)

                    saveExcel({
                    data: this.deviceBatchDataAquaculture,
                        fileName: fileName,
                        columns: [
                            { field: 'BatchID', title: 'ID' },
                            { field: 'Processed', title: 'Processed' },
                            { field: 'StartDateTime', title: 'Started' },
                            { field: 'EndDateTime', title: 'Finished' },
                            { field: 'ProtocolOEMCode', title: 'Code' },
                            { field: 'ProtocolOEMDesc', title: 'Protocol' },
                            { field: 'NumberOfFish', title: 'Number of Fish' },
                            { field: 'FishID_1', title: 'Fish 1 ID' },
                            { field: 'PackageQuantity_1', title: 'Package 1 Quantity' },
                            { field: 'TotalMotility_1', title: 'Fish 1 Total Motility' },
                            { field: 'Concentration_1', title: 'Fish 1 Concentration' },
                            { field: 'Grade_1', title: 'Fish 1 Grade' },
                            { field: 'Cryoprotectant_1', title: 'Package 1 Cryoprotectant' },
                            { field: 'FishID_2', title: 'Fish 2 ID' },
                            { field: 'PackageQuantity_2', title: 'Package 2 Quantity' },
                            { field: 'TotalMotility_2', title: 'Fish 2 Total Motility' },
                            { field: 'Concentration_2', title: 'Fish 2 Concentration' },
                            { field: 'Grade_2', title: 'Fish 2 Grade' },
                            { field: 'Cryoprotectant_2', title: 'Package 2 Cryoprotectant' },
                            { field: 'FishID_3', title: 'Fish 3 ID' },
                            { field: 'PackageQuantity_3', title: 'Package 3 Quantity' },
                            { field: 'TotalMotility_3', title: 'Fish 3 Total Motility' },
                            { field: 'Concentration_3', title: 'Fish 3 Concentration' },
                            { field: 'Grade_3', title: 'Fish 3 Grade' },
                            { field: 'Cryoprotectant_3', title: 'Package 3 Cryoprotectant' },
                            { field: 'Flow Tolerance', title: 'Flow Tolerance' },
                            { field: 'Process Time', title: 'Process Time' },
                            { field: 'Start Temp', title: 'Start Temp.' },
                            { field: 'End Temp', title: 'End Temp.' },
                            { field: 'Min Temp', title: 'Min Temp.' },
                            { field: 'Max Temp', title: 'Max Temp.' },
                            { field: 'Start Flow', title: 'Start Flow' },
                            { field: 'End Flow', title: 'End Flow' },
                            { field: 'Min Flow', title: 'Min Flow' },
                            { field: 'Max Flow', title: 'Max Flow' },
                        ],
                    });
                }
                else {
                    saveExcel({
                        data: this.deviceBatchData,
                        fileName: "deviceBatchData-advanced",
                        columns: [
                            { field: 'BatchID', title: 'ID' },
                            { field: 'Started', title: 'Started' },
                            { field: 'Finished', title: 'Finished' },
                            { field: 'Code', title: 'Code' },
                            { field: 'Protocol', title: 'Protocol' },
                            { field: 'Product', title: 'Product' },
                            { field: 'Pack Qty', title: 'Pack Qty', },
                            { field: 'Pack Volume', title: 'Pack Volume', },
                            { field: 'Weight/Vol', title: 'Weight/Vol', },
                            { field: 'Temp Setpoint', title: 'Temp. Setpoint', },
                            { field: 'Temp Tolerance', title: 'Temp. Tolerance', },
                            { field: 'Flow Setpoint', title: 'Flow Setpoint', },
                            { field: 'Flow Tolerance', title: 'Flow Tolerance', },
                            { field: 'Process Time', title: 'Process Time', },
                            { field: 'Start Temp', title: 'Start Temp.', },
                            { field: 'End Temp', title: 'End Temp.', },
                            { field: 'Min Temp', title: 'Min Temp.', },
                            { field: 'Max Temp', title: 'Max Temp.', },
                            { field: 'Start Flow', title: 'Start Flow', },
                            { field: 'End Flow', title: 'End Flow', },
                            { field: 'Min Flow', title: 'Min Flow', },
                            { field: 'Max Flow', title: 'Max Flow', },
                        ],
                    });
                }
            },
            dataSelectionChange() {
                console.log("dataSelectionChange clicked!");                
            },
            batchCountUpdate() {
                console.log("batchCountUpdate() clicked");

                this.newBatch = true;
            }
        }
    }
</script>

<style>
    #item-count {
        float: right;
        font-size: 13px;
        font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";        
    }

    .show-grid {
        display: block;
    }

    .hide-grid {
        display: none;
    }
</style>
